export const sectionData = [
    {
        id: 1,
        title: 'Антивирусы',
        text: 'Защитите компьютер и смартфон от кражи личных данных, вирусной атаки, воровства денег с карт, взлома почты и социальных сетей.',
        hrefText: 'Подробнее об антивирусах',
        href: '/internet/antivirus',
        src: 'antivirus.png',
    },
    {
        id: 2,
        title: 'Бонусы скорости',
        text: 'Расширьте возможности своего тарифа и пользуйтесь интернетом на высокой скорости.',
        hrefText: 'Подробнее о бонусах скорости',
        href: '/speedup',
        src: 'speed.png',
    },
    {
        id: 3,
        title: 'Родительский контроль',
        text: 'Позаботьтесь о защите ваших детей – пусть они открывают только подходящие по возрасту сайты и приложения.',
        hrefText: 'Подробнее о родительском контроле',
        href: 'https://lk.dom.ru/internet/safekids',
        src: 'people.png',
    },
    {
        id: 4,
        title: 'Домашняя сеть Wi-Fi',
        text: 'Решение для больших квартир и сложных планировок, чтобы интернет был одинаково стабильным и быстрым во всех комнатах.',
        hrefText: 'Подробнее о сети Wi-Fi',
        href: '/internet/home-wifi',
        src: 'wifi.png',
    },
];
